import React, { useContext } from "react";
import BlogContext from "../../../context/BlogContext/BlogContext";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import {
  delete_Image_Permanent,
  delete_Multi_Image_Permanent,
} from "../apis/SliderApi/SliderApi";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { Zoom, toast } from "react-toastify";
import Switch from "@material-ui/core/Switch";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc } from "../../../utils";
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { UploadCloud } from "react-feather";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { SketchPicker } from "react-color";
import { fontFamily, fontWeight } from "../../../../constant";
import CommonColor from "../../../common/CommonColor";

const BlogDetailStyle = () => {
  const {
    settingFormData,
    setSettingFormData,
    isBackgroundColor2,
    setIsBackgroundColor2,
    boxSectionDetail,
    setBoxSectionDetail,
    backImageToggleDetail,
    setBackImageToggleDetail,
    isImageUpload,
    setIsImageUpload,
  } = useContext(BlogContext);
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const handleChangeServiceDetailSection = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".service-detail-section"]: {
          ...prev[".service-detail-section"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeTeamSectionDetailTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .details-title"]: {
          ...prev[".personal-details .details-title"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsP = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details p"]: {
          ...prev[".personal-details p"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsListInfo = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .info-list"]: {
          ...prev[".personal-details .info-list"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsListInfoLi = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .info-list li"]: {
          ...prev[".personal-details .info-list li"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsOrderList = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .order-list"]: {
          ...prev[".personal-details .order-list"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsOrderListLi = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .order-list li"]: {
          ...prev[".personal-details .order-list li"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeProductDetailsOrderListLiBefore = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".personal-details .order-list li:before"]: {
          ...prev[".personal-details .order-list li:before"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeSideThumbImg = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".side_thumb img"]: {
          ...prev[".side_thumb img"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeSideContentMeta = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".side_content .side_meta"]: {
          ...prev[".side_content .side_meta"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeSideContentTitle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".side_content .side_title"]: {
          ...prev[".side_content .side_title"],
          [name]: value,
        },
      };
    });
  };
  const handleChangeSideContentTitleA = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [".side_content .side_title a"]: {
          ...prev[".side_content .side_title a"],
          [name]: value,
        },
      };
    });
  };

  /**
   * delete image permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: settingFormData?.[".service-detail-section.bg-image"]?.[
            "background-image"
          ]
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setSettingFormData({
            ...settingFormData,
            ".service-detail-section.bg-image": { "background-image": "" },
          });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };
  /**
   * image reupload
   */
  const reupload = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  return (
    <>
      <Row className="mt-4">
        <h2 className="mb-3">Style for Blog Detail </h2>
        <h4 className="mb-3">Make change in main Service Detail section</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">{"Padding (default : 60)"}</Label>
          <Input
            className="form-control"
            name="padding"
            type="number"
            placeholder="Padding"
            value={settingFormData?.[".service-detail-section"]?.["padding"]
              ?.split(" ")[0]
              ?.replace(/px/g, "")}
            onChange={(e) => handleChangeServiceDetailSection(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <div className="d-flex align-items-center">
            <Label htmlFor="validationCustom03">
              {isBackgroundColor2
                ? "Add Background Color"
                : "Remove Background Color"}
            </Label>
            <Switch
              checked={isBackgroundColor2}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(e) => {
                setIsBackgroundColor2(e.target.checked);
                setSettingFormData((prev) => {
                  if (e.target.checked) {
                    if (boxSectionDetail) {
                      return {
                        ...prev,
                        [".service-detail-section"]: {
                          "background-color": "#fafafa",
                          padding:
                            settingFormData?.[".service-detail-section"]?.[
                              "padding"
                            ],
                          width: settingFormData?.[".service-detail-section"]?.[
                            "width"
                          ]?.replace("rem)", ""),
                          margin: settingFormData?.[
                            ".service-detail-section"
                          ]?.["margin"]
                            ?.split(" ")[0]
                            ?.replace(/px/g, ""),
                          "border-radius": settingFormData?.[
                            ".service-detail-section"
                          ]?.["border-radius"]?.replace(/rem/g, ""),
                        },
                      };
                    } else {
                      return {
                        ...prev,
                        [".service-detail-section"]: {
                          "background-color": "#fafafa",
                          padding:
                            settingFormData?.[".service-detail-section"]?.[
                              "padding"
                            ],
                        },
                      };
                    }
                  } else {
                    if (boxSectionDetail) {
                      return {
                        ...prev,
                        [".service-detail-section"]: {
                          padding:
                            settingFormData?.[".service-detail-section"]?.[
                              "padding"
                            ],
                          width: settingFormData?.[".service-detail-section"]?.[
                            "width"
                          ]?.replace("rem)", ""),
                          margin: settingFormData?.[
                            ".service-detail-section"
                          ]?.["margin"]
                            ?.split(" ")[0]
                            ?.replace(/px/g, ""),
                          "border-radius": settingFormData?.[
                            ".service-detail-section"
                          ]?.["border-radius"]?.replace(/rem/g, ""),
                        },
                      };
                    } else {
                      return {
                        ...prev,
                        [".service-detail-section"]: {
                          padding:
                            settingFormData?.[".service-detail-section"]?.[
                              "padding"
                            ],
                        },
                      };
                    }
                  }
                });
              }}
            />
          </div>
          {isBackgroundColor2 && (
            <CommonColor
              color={
                settingFormData?.[".service-detail-section"]?.[
                  "background-color"
                ]
              }
              setSettingFormData={setSettingFormData}
              className={".service-detail-section"}
              classProperty={"background-color"}
              label={"Select Background Color"}
            />
          )}
        </Col>
        <p>{"Box Section : convert your Detail section to Box section"}</p>
        <div>
          <Switch
            checked={boxSectionDetail}
            inputProps={{ "aria-label": "controlled" }}
            onChange={(e) => {
              setBoxSectionDetail(e.target.checked);
              setSettingFormData((prev) => {
                return {
                  ...prev,
                  ".service-detail-section": {
                    padding: settingFormData?.[".service-detail-section"]?.[
                      "padding"
                    ]
                      ?.split(" ")[0]
                      ?.replace(/px/g, ""),
                    "background-color":
                      settingFormData?.[".service-detail-section"]?.[
                        "background-color"
                      ],
                  },
                };
              });
            }}
          />
        </div>
        {boxSectionDetail && (
          <>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Width (Default : 10)"}
              </Label>
              <Input
                className="form-control"
                name="width"
                type="number"
                placeholder="width"
                value={settingFormData?.[".service-detail-section"]?.[
                  "width"
                ]?.replace("rem)", "")}
                onChange={(e) => handleChangeServiceDetailSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Margin (Default : 0)"}
              </Label>
              <Input
                className="form-control"
                name="margin"
                type="number"
                placeholder="margin"
                value={settingFormData?.[".service-detail-section"]?.["margin"]
                  ?.split(" ")[0]
                  ?.replace(/px/g, "")}
                onChange={(e) => handleChangeServiceDetailSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
            <Col md="4 mb-3">
              <Label htmlFor="validationCustom03">
                {"Border Radius (Default : 3)"}
              </Label>
              <Input
                className="form-control"
                name="border-radius"
                type="number"
                placeholder="Border Radius"
                value={settingFormData?.[".service-detail-section"]?.[
                  "border-radius"
                ]?.replace(/rem/g, "")}
                onChange={(e) => handleChangeServiceDetailSection(e)}
                style={{ borderRadius: "0", color: "black" }}
              />
            </Col>
          </>
        )}
      </Row>
      <hr />
      <Row className="mt-4">
        <Col md="12 mb-3">
          <h4 className="mb-3">Add Background Image in Detail section </h4>

          <p>do you want to upload Background image</p>
          <Switch
            checked={backImageToggleDetail}
            inputProps={{ "aria-label": "controlled" }}
            onChange={(e) => {
              setBackImageToggleDetail(e.target.checked);
              setSettingFormData((prev) => {
                if (e.target.checked) {
                  return {
                    ...prev,
                    image: "",
                    ".service-detail-section.bg-image": {},
                    ".service-detail-section.bg-image::before": {
                      "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
                    },
                  };
                } else {
                  return {
                    ...prev,
                    image: "",
                    ".service-detail-section.bg-image": {},
                    ".service-detail-section.bg-image::before": {},
                  };
                }
              });
            }}
          />
          {backImageToggleDetail && (
            <>
              {" "}
              <Col md="6 mb-3">
                <Dividers divide="IMAGE" />
                <p className="mb-4">
                  File type required JPG, PNG (1905px X 986px)
                </p>
              </Col>
              <Row>
                <Col md="4 mb-3">
                  <div
                    className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      onClick={() => {
                        OpenModalCommonFunc(
                          Cases.PRODUCT_UPLOAD,
                          setAllPopupState
                        );
                        setIsImageUpload((prev) => {
                          return {
                            isList: false,
                            isDetails: true,
                          };
                        });
                      }}
                    >
                      <UploadCloud />
                    </span>
                    {settingFormData?.[".service-detail-section.bg-image"]?.[
                      "background-image"
                    ] && (
                      <img
                        src={
                          settingFormData?.[
                            ".service-detail-section.bg-image"
                          ]?.["background-image"] || ""
                        }
                        alt=""
                        style={{
                          width: "85%",
                          height: "90px",
                          objectFit: "contain",
                          position: "absolute",
                        }}
                        onClick={() => {
                          OpenModalCommonFunc(
                            Cases.PRODUCT_UPLOAD,
                            setAllPopupState
                          );
                          setSettingFormData((prev) => {
                            return {
                              ...prev,
                              image:
                                settingFormData?.[
                                  ".service-detail-section.bg-image"
                                ]?.["background-image"],
                            };
                          });
                          setIsImageUpload((prev) => {
                            return {
                              isList: false,
                              isDetails: true,
                            };
                          });
                        }}
                      />
                    )}
                    {settingFormData?.[".service-detail-section.bg-image"]?.[
                      "background-image"
                    ] && (
                      <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="close"
                        style={{
                          color: "red",
                          position: "absolute",
                          top: "-22px",
                          left: "1px",
                        }}
                        onClick={() => deleteImagePermanent()}
                      >
                        <Close
                          style={{
                            fontSize: "25px",
                            fontWeight: "bold",
                          }}
                        />
                      </IconButton>
                    )}
                  </div>
                </Col>
                <Col md="6 mb-3">
                  <h4 className="mb-3">
                    Add Background color in Detail section
                  </h4>
                  <h4 className="mb-3"></h4>
                  <Col md="6 mb-3">
                    <CommonColor
                      color={
                        settingFormData?.[
                          ".service-detail-section.bg-image::before"
                        ]?.["background-color"]
                      }
                      setSettingFormData={setSettingFormData}
                      className={".service-detail-section.bg-image::before"}
                      classProperty={"background-color"}
                      label={"Select Background Color"}
                    />
                  </Col>
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">Make change in personal details Title</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Size (Default : 24)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="Font Size"
            value={settingFormData?.[".personal-details .details-title"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeTeamSectionDetailTitle(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Weight (Default : 600)"}
          </Label>
          <select
            name="font-weight"
            id="font-weight"
            className="form-select"
            value={
              settingFormData?.[".personal-details .details-title"]?.[
                "font-weight"
              ]
            }
            onChange={(e) => handleChangeTeamSectionDetailTitle(e)}
            style={{ borderRadius: "0", color: "black" }}
          >
            <option value="">--select--</option>
            {fontWeight.map((elem) => {
              return (
                <option value={elem["font-weight"]}>
                  {elem["font-weight"]}
                </option>
              );
            })}
          </select>
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">Make change in personal details Paragraph</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 20)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".personal-details p"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsP(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Line Height (Default : 1.6)"}
          </Label>
          <Input
            className="form-control"
            name="line-height"
            type="number"
            placeholder="Line Height"
            value={settingFormData?.[".personal-details p"]?.["line-height"]}
            onChange={(e) => handleChangeProductDetailsP(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Size (Default : 18)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="Font Size"
            value={settingFormData?.[".personal-details p"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsP(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <h4 className="mb-3">personal-details | info-list</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 30)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".personal-details .info-list"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsListInfo(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">personal-details | info-list li</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 15)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".personal-details .info-list li"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsListInfoLi(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Size (Default : 18)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="Font Size"
            value={settingFormData?.[".personal-details .info-list li"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsListInfoLi(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">personal-details | order-list</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 30)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".personal-details .order-list"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsOrderList(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">personal-details | order-list li</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Padding Left (Default : 25)"}
          </Label>
          <Input
            className="form-control"
            name="padding-left"
            type="number"
            placeholder="Padding Left"
            value={settingFormData?.[".personal-details .order-list li"]?.[
              "padding-left"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsOrderListLi(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 15)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".personal-details .order-list li"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsOrderListLi(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Size (Default : 18)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="Font Size"
            value={settingFormData?.[".personal-details .order-list li"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsOrderListLi(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">personal-details | order-list li:before</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Family (Default : FontAwesome)"}
          </Label>
          <select
            name="font-family"
            id="font-family"
            className="form-select"
            value={
              settingFormData?.[".personal-details .order-list li:before"]?.[
                "font-family"
              ]
            }
            onChange={(e) => handleChangeProductDetailsOrderListLiBefore(e)}
            style={{ borderRadius: "0", color: "black" }}
          >
            <option value="">--select--</option>
            {fontFamily.map((elem) => {
              return (
                <option value={elem["font-family"]}>
                  {elem["font-family"]}
                </option>
              );
            })}
          </select>
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">{"Top (Default : 3)"}</Label>
          <Input
            className="form-control"
            name="top"
            type="number"
            placeholder="Top"
            value={settingFormData?.[
              ".personal-details .order-list li:before"
            ]?.["top"]?.replace(/px/g, "")}
            onChange={(e) => handleChangeProductDetailsOrderListLiBefore(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <CommonColor
            color={
              settingFormData?.[".personal-details .order-list li:before"]?.[
                "color"
              ]
            }
            setSettingFormData={setSettingFormData}
            className={".personal-details .order-list li:before"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">side_thumb img</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">{"Height (Default : 90)"}</Label>
          <Input
            className="form-control"
            name="height"
            type="number"
            placeholder="Height"
            value={settingFormData?.[".side_thumb img"]?.["height"]?.replace(
              /px/g,
              ""
            )}
            onChange={(e) => handleChangeSideThumbImg(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">{"Width (Default : 90)"}</Label>
          <Input
            className="form-control"
            name="width"
            type="number"
            placeholder="Width"
            value={settingFormData?.[".side_thumb img"]?.["width"]?.replace(
              /px/g,
              ""
            )}
            onChange={(e) => handleChangeSideThumbImg(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Border Radius (Default : 4)"}
          </Label>
          <Input
            className="form-control"
            name="border-radius"
            type="number"
            placeholder="Border Radius"
            value={settingFormData?.[".side_thumb img"]?.[
              "border-radius"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeSideThumbImg(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">side_content side_meta</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"font-size (Default : 14)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="font-size"
            value={settingFormData?.[".side_content .side_meta"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeSideContentMeta(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <CommonColor
            color={settingFormData?.[".side_content .side_meta"]?.["color"]}
            setSettingFormData={setSettingFormData}
            className={".side_content .side_meta"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Weight (Default : 600)"}
          </Label>
          <select
            name="font-weight"
            id="font-weight"
            className="form-select"
            value={
              settingFormData?.[".side_content .side_meta"]?.["font-weight"]
            }
            onChange={(e) => handleChangeSideContentMeta(e)}
            style={{ borderRadius: "0", color: "black" }}
          >
            <option value="">--select--</option>
            {fontWeight.map((elem) => {
              return (
                <option value={elem["font-weight"]}>
                  {elem["font-weight"]}
                </option>
              );
            })}
          </select>
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Margin Bottom (Default : 3)"}
          </Label>
          <Input
            className="form-control"
            name="margin-bottom"
            type="number"
            placeholder="Margin Bottom"
            value={settingFormData?.[".side_content .side_meta"]?.[
              "margin-bottom"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeSideContentMeta(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">side_content side_title</h4>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"font-size (Default : 16)"}
          </Label>
          <Input
            className="form-control"
            name="font-size"
            type="number"
            placeholder="font-size"
            value={settingFormData?.[".side_content .side_title"]?.[
              "font-size"
            ]?.replace(/px/g, "")}
            onChange={(e) => handleChangeSideContentTitle(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Font Weight (Default : 700)"}
          </Label>
          <select
            name="font-weight"
            id="font-weight"
            className="form-select"
            value={
              settingFormData?.[".side_content .side_title"]?.["font-weight"]
            }
            onChange={(e) => handleChangeSideContentTitle(e)}
            style={{ borderRadius: "0", color: "black" }}
          >
            <option value="">--select--</option>
            {fontWeight.map((elem) => {
              return (
                <option value={elem["font-weight"]}>
                  {elem["font-weight"]}
                </option>
              );
            })}
          </select>
        </Col>
        <Col md="4 mb-3">
          <CommonColor
            color={settingFormData?.[".side_content .side_title"]?.["color"]}
            setSettingFormData={setSettingFormData}
            className={".side_content .side_title"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
        <Col md="4 mb-3">
          <Label htmlFor="validationCustom03">
            {"Line Height (Default : 1.5)"}
          </Label>
          <Input
            className="form-control"
            name="line-height"
            type="number"
            placeholder="Line Height"
            value={
              settingFormData?.[".side_content .side_title"]?.["line-height"]
            }
            onChange={(e) => handleChangeSideContentTitle(e)}
            style={{ borderRadius: "0", color: "black" }}
          />
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <h4 className="mb-3">side_content side_title a link</h4>
        <Col md="4 mb-3">
          <CommonColor
            color={settingFormData?.[".side_content .side_title a"]?.["color"]}
            setSettingFormData={setSettingFormData}
            className={".side_content .side_title a"}
            classProperty={"color"}
            label={"Select Color"}
          />
        </Col>
      </Row>
    </>
  );
};

export default BlogDetailStyle;
